import React, { useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./ViewAccountManagement.css";

const ViewAccountManagement = () => {

  useEffect(() => {
    document.title = `View-Account-Management | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <h1>Member View details</h1>
                    <div className="vnfro shadow-md-none">
                      <div className="back-chayo d-flex align-items-center gap-3 mb-3">
                        {/* Profile Image */}
                        <div className="leki">
                          <img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/orry.png'}
                            alt="Profile"
                            className="img-fluid"
                          />
                        </div>

                        {/* Store Info */}
                        <div className="infea fgfr ott2">
                          <p>Customer Name</p>
                          <h5>Emma Jobson Willison</h5>
                          <div className="ids">Employee ID #: 87385 </div>
                          <div className="vigyo"><img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/vigyo-frame.png'} alt="Profile" className="img-fluid" /> emaawillson885</div>
                        </div>
                      </div>

                      <div className="infea fgfr">
                        <h5>Sales Manager</h5>
                        <p>Marketing</p>
                      </div>

                      <div className="d-flex flex-wrap gap-3">
                        <div className="vi-sha-info">
                          <div className="labu">Cell Phone</div>
                          <div className="labu-ans">+1 (469) 532-2382</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Address</div>
                          <div className="labu-ans">123 Main Street, Los Angeles, California, 90001 </div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Country</div>
                          <div className="labu-ans">USA</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Personal Email</div>
                          <div className="labu-ans">e.wilson@bluefaucet.com</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Company Email</div>
                          <div className="labu-ans">e.wilson@bluefaucet.com</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Level</div>
                          <div className="labu-ans">C level</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Supervisor</div>
                          <div className="labu-ans">Joan Smith</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Authorized Pages</div>
                          <div className="labu-ans">10</div>
                        </div>
                        <div className="vi-sha-info">
                          <div className="labu">Temp Password</div>
                          <div className="labu-ans">*********</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewAccountManagement;